import { cx } from '@emotion/css';
import React from 'react';
import { HexColorPicker } from 'react-colorful';
import { ix } from '../../../utils/ix';
import { Typography } from '../../electrons';
import { InputField } from '../../molecules';
import useStyles from './ColorPicker.styles';
export function ColorPicker(props) {
    const classes = useStyles();
    return (React.createElement("div", { id: props.id, className: cx(props.className, classes.root) },
        React.createElement(HexColorPicker, { id: ix(props.id, 'picker'), color: props.value, onChange: props.onChange }),
        React.createElement("div", { className: classes.hexFieldContainer },
            React.createElement(Typography, { variant: "body2" }, "HEX"),
            React.createElement(InputField, { id: ix(props.id, 'field'), className: classes.hexField, value: props.value.toUpperCase(), onChange: (e) => props.onChange(e.target.value), type: "hex", fullWidth: true }))));
}
//# sourceMappingURL=ColorPicker.js.map